"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

var _reactI18next = require("react-i18next");

var _core = require("@material-ui/core");

var _solarReact = require("@solar/solar-react");

var _excluded = ["classes", "info"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var LoadingPage = function LoadingPage(_ref) {
  var classes = _ref.classes,
      info = _ref.info,
      other = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement(_reactI18next.Translation, {
    ns: ['app']
  }, function (t) {
    return /*#__PURE__*/_react["default"].createElement(_solarReact.Flex, _extends({
      fullColumn: true,
      className: classes.root
    }, other), /*#__PURE__*/_react["default"].createElement(_solarReact.ResponsiveAppBar, {
      title: t('loading'),
      disableShadow: true
    }), /*#__PURE__*/_react["default"].createElement(_solarReact.ScrollableContent, {
      classes: {
        content: classes.content
      }
    }, /*#__PURE__*/_react["default"].createElement(_solarReact.ResponsiveSheet, {
      elevation: 2,
      classes: {
        root: classes.sheet
      }
    }, /*#__PURE__*/_react["default"].createElement(_core.Typography, {
      variant: "body2",
      noWrap: true
    }, t('loadingInfo')), info && /*#__PURE__*/_react["default"].createElement(_core.Typography, {
      variant: "caption"
    }, info))));
  });
};
/* prettier-ignore */


var _default = (0, _styles.withStyles)(function (theme) {
  return {
    root: {}
  };
})(LoadingPage);

exports["default"] = _default;